var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form-modelCols',{staticClass:"pb-1 mx-1 mt-1",attrs:{"model":_vm.getFormModel(['button_type#4', 'button_name#5']),"values":_vm.data,"errors":_vm.errors,"config":{ dense: true, readonly: _vm.readonly, hideDetails: true }},on:{"validate":function($event){_vm.$emit('change');
      _vm.submit(true);}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }